import React, { useState } from "react";
import CoursesData from "../content.json";
import { BsLightningFill } from "react-icons/bs";
import { Helmet } from "react-helmet";


import Courses from "../Components/Courses"

function MEd() {

  // document.getElementsByClassName("CourseContainer").style.marginTop="0";
  const [MCAData] = useState(CoursesData.Courses[1]);
  return (
		<>
			<Helmet>
				<title>M.Ed. | University of Education</title>
			</Helmet>
			<div className="PageContainer">
				<div className="">
					{/* <div className="CourseBanner HeaderImg">
						<img src={MCAData.course_banner} alt="MCA-banner" />
					</div> */}

					<div id="Heading" className="CourseTitle" data-aos="fade-up">
						<h1>{MCAData.course_fullname}</h1>
					</div>
					<br />
					<p className="CourseDesc" data-aos="fade-up" style={{ marginBottom: "15px" }}>
						M.Ed is a two years post-graduate professional degree course programme. The aim of the course is to deepen the knowledge and understanding of the learners in the field of education. It prepare a quality teacher educators with professional expertise. The curriculum highlights the Psychology of learning, History and Political Economy, Educational studies, &amp; Philosophy, Sociology, Teacher education, Educational Policy, etc.
					</p>
					<p className="CourseDesc" data-aos="fade-up" style={{ marginBottom: "15px" }}>
						The curriculum prepare teachers for specialization in Elementary Education and Secondary Education specialization. The specialized subjects such as Educational Administration, Inclusive Education, Educational Technology, Computer Education, Adult Education etc., prepare teachers for further innovative and developmental work in the field of education.
					</p>
					<p className="CourseDesc" data-aos="fade-up">
						The learners are specialized in their concerned subject. The curriculum emphasizes on education research, the course has a strong research component which includes dissertation writing. The completion of programme shall lead to M.Ed degree with different specialization.
					</p>
					<br />

					<div className="CourseDetailsContainer">
						<div id="Secondary_Heading" data-aos="fade-up">
							<h3>Course Detail</h3>
						</div>
						<div className="CourseTable" data-aos="fade-up">
							<table>
								<tr data-aos="fade-up">
									<td>Course -</td>
									<td>{MCAData.course_fullname}</td>
								</tr>
								<tr data-aos="fade-up">
									<td>Recognizing body -</td>
									<td>{MCAData.course_certification}</td>
								</tr>

								<tr data-aos="fade-up">
									<td>Duration -</td>
									<td>(2 Academic years) full time</td>
								</tr>
								<tr data-aos="fade-up">
									<td>No of Semesters -</td>
									<td>{MCAData.course_sem}</td>
								</tr>
								<tr data-aos="fade-up">
									<td>Total Seats / Intake -</td>
									<td>{MCAData.course_seat}</td>
								</tr>
								<tr data-aos="fade-up">
									<td>Eligibility criteria -</td>
									<td>{MCAData.course_eligibility}</td>
								</tr>
								<tr data-aos="fade-up">
									<td>Fees -</td>
									<td>{MCAData.course_fee_per_sem}</td>
								</tr>
								<tr data-aos="fade-up">
									<td>Affiliation -</td>
									<td>{MCAData.university}</td>
								</tr>
							</table>
						</div>
					</div>

					<div className="CourseDetailsProcess" data-aos="fade-up">
						{/* ELIGIBILITY CRITERIA */}
						<div
							className="Section"
							style={{ marginBottom: "30px" }}
							data-aos="fade-up"
						>
							<div className="SubHeading">
								<h4>Eligibility Criteria</h4>
							</div>
							<p style={{ marginBottom: "15px", lineHeight: "1.6" }}>
								The admission in M.Ed course shall be done through Jharkhand combined entrance competitive examination board website.
							</p>
							<ul>
								<li
									style={{
										display: "flex",
										gap: "10px",
										alignItems: "flex-start",
										lineHeight: "1.6",
										marginBottom: "10px",
									}}
								>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										Candidate with at least 50% (45% in case of SC/ST/OBC PwD &amp; other reserved categories) either Bachelor's Degree and/or in Master's Degree in Science/Social Science/Humanities/Commerce, Bachelor's in Engineering or Technology with specialization in Science and Mathematics with 55% (50% in case of SC/ST/OBC PwD and other reserved categories) marks or any other qualification equivalent thereto, are eligible for consideration in admission to M.Ed course. For admission in M.Ed, the minimum qualification shall be B.Ed.
									</div>
								</li>
								<li
									style={{
										display: "flex",
										gap: "10px",
										alignItems: "flex-start",
										lineHeight: "1.6",
										marginBottom: "10px",
									}}
								>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										The candidate shall have to choose only one subject (within a subject category) which she/he must have studied in the qualifying degree i.e., Bachelor's Degree or Master's Degree for at least 200 marks and obtained at least 50% in this subject. The subject will henceforth be referred to as the teaching subject in the B.Ed/M.Ed course.
									</div>
								</li>
								<li
									style={{
										display: "flex",
										gap: "10px",
										alignItems: "flex-start",
										lineHeight: "1.6",
										marginBottom: "10px",
									}}
								>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										There is no restriction in the passing year to apply in B.Ed/M.Ed course.
									</div>
								</li>
							</ul>
						</div>

						{/* 4. AVAILABILITY OF SEATS */}
						<div
							className="Section"
							style={{ marginBottom: "30px" }}
							data-aos="fade-up"
						>
							<div className="SubHeading">
								<h4>4. AVAILABILITY OF SEATS :</h4>
							</div>
							<ul>
								<li
									style={{
										display: "flex",
										gap: "10px",
										alignItems: "flex-start",
										lineHeight: "1.6",
										marginBottom: "10px",
									}}
								>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										(a) The total no. of students to be admitted to the M.Ed.
										Course shall be fixed by the Vinoba Bhave University in
										accordance with norms of the National Council for Teacher
										Education (NCTE) from time to time.
									</div>
								</li>
								<li
									style={{
										display: "flex",
										gap: "10px",
										alignItems: "flex-start",
										lineHeight: "1.6",
										marginBottom: "10px",
									}}
								>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										(b) The admission will be open to all students of
										Jharkhand State and the nation over.
									</div>
								</li>
							</ul>
						</div>

						{/* 5. RESERVATION */}
						<div
							className="Section"
							style={{ marginBottom: "30px" }}
							data-aos="fade-up"
						>
							<div className="SubHeading">
								<h4>5. RESERVATION :</h4>
							</div>
							<ul>
								<li
									style={{
										display: "flex",
										gap: "10px",
										alignItems: "flex-start",
										lineHeight: "1.6",
										marginBottom: "10px",
									}}
								>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										(a) As per Government of Jharkhand Rules declared from
										time to time and adopted by the University.
									</div>
								</li>
								<li
									style={{
										display: "flex",
										gap: "10px",
										alignItems: "flex-start",
										lineHeight: "1.6",
										marginBottom: "10px",
									}}
								>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										(b) Seats left unfilled in any of the reserved category
										by reason of the fact that no eligible candidate is
										available in the respective category shall be filled up
										by admitting candidates available from other reserved
										categories keeping the hierarchy of reserved/unreserved
										into consideration.
									</div>
								</li>
							</ul>
						</div>

						{/* 6. DISQUALIFICATION */}
						<div
							className="Section"
							style={{ marginBottom: "30px" }}
							data-aos="fade-up"
						>
							<div className="SubHeading">
								<h4>6. DISQUALIFICATION :</h4>
							</div>
							<ul>
								<li
									style={{
										display: "flex",
										gap: "10px",
										alignItems: "flex-start",
										lineHeight: "1.6",
										marginBottom: "10px",
									}}
								>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										(a) No candidate shall be permitted to be registered as a
										student in any other course leading to diploma or Degree
										during the Academic Year of his/her study for the M.Ed.
										Course.
									</div>
								</li>
								<li
									style={{
										display: "flex",
										gap: "10px",
										alignItems: "flex-start",
										lineHeight: "1.6",
										marginBottom: "10px",
									}}
								>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										(b) No applicant shall be admitted who does not get
										himself/herself enrolled within the specified time.
									</div>
								</li>
								<li
									style={{
										display: "flex",
										gap: "10px",
										alignItems: "flex-start",
										lineHeight: "1.6",
										marginBottom: "10px",
									}}
								>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										(c) If its is found that the candidate has furnished any
										false information, his/her candidature shall be
										cancelled immediately.
									</div>
								</li>
								<li
									style={{
										display: "flex",
										gap: "10px",
										alignItems: "flex-start",
										lineHeight: "1.6",
										marginBottom: "10px",
									}}
								>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										(d) The decision of the University regarding admission
										would be final.
									</div>
								</li>
							</ul>
						</div>


					</div>



					<section>
						<Courses />
					</section>
				</div>
			</div>
		</>
	);
}

export default MEd;
